// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\n.org-info__wrapper[data-v-52e4ab52] {\n  border: 1px solid #bcbcbc54;\n  border-radius: 4px;\n  position: relative;\n}\n.org-info__title[data-v-52e4ab52] {\n  position: absolute;\n  top: -12px;\n  left: 14px;\n  background: white;\n  padding: 0 10px;\n}\n.theme--dark .org-info__title[data-v-52e4ab52] {\n  background: #424242;\n}", ""]);
// Exports
module.exports = exports;
